module.exports = __webpack_public_path__ + "static/media/abn_amro.cf8fa38b.png";